//refert to the theming section in the primeng documentation to explore all variables
//https://github.com/primefaces/primeng/blob/v18/packages/themes/src/presets/aura/base/index.ts

export const DefaultThemePreset = {
  semantic: {
    primary: {
      50: '#E0E4FF',
      100: '#B1BBFF',
      200: '#80E8EE',
      300: '#8292FF',
      400: '#7385FF',
      500: '#6377FF', //main color 
      600: '#596BE6',
      700: '#4F5FCC',
      800: '#3B4799',
      900: '#323C80',
      950: '#1E244C'
    },
    colorScheme: {
      light: {
        primary: {
          color: "{primary.500}",
          contrastColor: "{surface.0}",
          hoverColor: "{primary.600}",
          activeColor: "{primary.700}",
          gradient: "45deg, {primary.500} 0%, {primary.600} 49.5%, {primary.500} 100%",
          shadow: "0px 5px 20px -5px {primary.600}",
        }
      }
    }
  }
}